<template>
  <div class="advertisement">
    <div class="advertisement-header">
      <div class="advertisement-header-text">
        <!-- <h3>广告策划</h3>
        <p>提供全方位的广告策划服务，帮助客户实现其品牌推广和业务增长的目标。</p> -->
        <div @click="handleClick">发布信息</div>
      </div>
    </div>
    <common type="1"></common>
  </div>
</template>

<script>
import common from "../components/common";
export default {
  components: {
    common,
  },
  data() {
    return {
      dataList: [],
      total: 0,
      pageNo: 1,
      pageSize: 6,
    };
  },
  methods: {
    handleClick() {
      this.$router.push({ path: "/publish", query: { type: "1" } });
    },
  },
};
</script>

<style scoped lang="less">
.fontdemo(@size,@family,@weight,@color) {
  font-size: @size;
  font-family: @family;
  font-weight: @weight;
  color: @color;
}
.advertisement {
  width: 100%;
  &-header {
    width: 100%;
    height: 600px;
    background: url("../assets/background5.png") no-repeat;
    background-size: cover;
    display: flex;
    &-text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      margin-left: 110px;
      margin-top: 200px;
      div {
        width: 245px;
        height: 67px;
        background: #f9c92e;
        border-radius: 5px;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        .fontdemo(18px, "PingFangSC,PingFang SC", 500, #000);
        cursor: pointer;
        font-size: 29px;
      }
    }
  }
}
</style>
